import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabDirective, TabsModule } from 'ngx-bootstrap/tabs';
import { SlotReward } from '../../models/slots/slot-reward.model';
import { SlotTestResponse } from '../../models/slots/responses/api-slot-test-response.model';
import { ApiSlotsService } from '../../services/slots/api/api-slots.service';
import { AlertsService } from '../../services/alerts.service';
import { ModalsService } from '../../services/modals.service';
import { SlotRewardAddModalComponent } from './modals/slot-reward-add-modal/slot-reward-add-modal.component';
import { SlotRewardEditModalComponent } from './modals/slot-reward-edit-modal/slot-reward-edit-modal.component';
import { ConfigurationsBlockComponent } from '../configurations/configurations-block/configurations-block.component';
import { ConfigurationDef } from '../configurations/configurations-block/configuration-def.model';
import { SlotStatisticsTabComponent } from './tabs/slot-statistics-tab/slot-statistics-tab.component';

@Component({
  templateUrl: 'slots.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, TabDirective, TabsModule, SlotRewardAddModalComponent, SlotRewardEditModalComponent, ConfigurationsBlockComponent, SlotStatisticsTabComponent]
})
export class SlotsComponent implements OnInit {

  @ViewChild('addModal') addModal!: SlotRewardAddModalComponent;
  @ViewChild('editModal') editModal!: SlotRewardEditModalComponent;
  @ViewChild('statisticsTab') statisticsTab!: SlotStatisticsTabComponent;

  onSelectStatisticsTab(): void { this.statisticsTab.load(); }

  readonly slotConfigurations: ConfigurationDef[] = [
    { name: 'game_slot_feature_active', label: 'Feature Active', type: 'bool' },
    { name: 'game_slot_level_unlocked', label: 'Level Unlocked', type: 'number' },
    { name: 'game_slot_bet_base', label: 'Bet Base', type: 'number' },
    { name: 'game_slot_jackpot_min', label: 'Jackpot Min', type: 'number' },
    { name: 'game_slot_jackpot_max', label: 'Jackpot Max', type: 'number' },
    { name: 'game_slot_jackpot_period', label: 'Jackpot Period', type: 'number' },
  ];

  slotRewards: SlotReward[] = [];

  isTestPanelOpen: boolean = false;
  testLaunchCount: number = 100;
  isTestLoading: boolean = false;
  testResult: SlotTestResponse | null = null;

  constructor(
    private apiSlotsService: ApiSlotsService,
    private alertsService: AlertsService,
    private modalsService: ModalsService
  ) {}

  ngOnInit(): void {
    this.refreshSlotRewards();
  }

  onClickAdd(): void {
    this.addModal.show(() => this.refreshSlotRewards());
  }

  onClickEdit(reward: SlotReward): void {
    this.editModal.show(reward.rewardRank, reward.multiplier, reward.rarityWeight, reward.isJackpot, () => this.refreshSlotRewards());
  }

  onClickDelete(reward: SlotReward): void {
    this.modalsService.showConfirmModal(() => {
      this.apiSlotsService.deleteSlotReward(reward.rewardRank).then(
        () => {
          this.alertsService.displayAlertSuccess('Slot reward deleted !');
          this.refreshSlotRewards();
        }, error => {
          this.alertsService.displayAlertError('Error deleting slot reward : ' + error);
        }
      );
    });
  }

  onClickTest(): void {
    this.isTestLoading = true;
    this.testResult = null;
    this.apiSlotsService.testSlot(this.testLaunchCount).then(
      response => {
        this.isTestLoading = false;
        this.testResult = response;
      }, error => {
        this.isTestLoading = false;
        this.alertsService.displayAlertError('Error testing slot : ' + error);
      }
    );
  }

  private refreshSlotRewards(): void {
    this.apiSlotsService.getSlotRewards().then(
      response => {
        this.slotRewards = response.results;
      }, error => {
        this.alertsService.displayAlertError('Error loading slot rewards : ' + error);
      }
    );
  }
}
